export default __webpack_public_path__ + "static/media/robovideo.a9199ae6.mp4";